import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { FleetMarquee } from "@/components/FleetMarquee";
import { Features } from "@/components/Features";
import { WaitlistSection } from "@/components/WaitlistSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export default function ComingSoon() {
  return (
    <main
      data-testid="coming-soon-page"
      className="relative min-h-screen w-full bg-[#1e2528] text-[#f7f7f7] font-body overflow-x-hidden"
    >
      <Navbar />
      <Hero />
      <FleetMarquee />
      <Features />
      <WaitlistSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
